import React, { useState, useEffect } from "react";
import "./../styles/ComplaintReport.scss";
import Api from "../common/api";

const ComplaintReport = () => {
  const [datas, setData] = useState([]);
  const [filterDatas, filterData] = useState([]);
  const [years, setYears] = useState([]);
  const [activeYear, setActiveYear] = useState([]);

  React.useEffect(() => {
    Api.get("/Documents/list/4").then((res) => {
      setData(res.data.items);
      var year = [];
      res.data.items.map((val, index) => {
        var newYear = new Date(val.Create_date.split("(")[1].split(")")[0] * 1)
          .toLocaleDateString("tr-TR")
          .split(".")[2];
        if (year.findIndex((x) => x.name == newYear) == -1) {
          year.push({
            id: index,
            name: newYear,
          });
        }
      });
      setYears(year);
      setActiveYear(year[0].name);
    });
  }, []);

  return (
    <>
      <div className="top-year-section ">
        <ul className="row">
          {years
            ? years.map((tab) => {
              return (
                <>
                  <li
                    className={
                      tab.name == activeYear ? "years active" : "years"
                    }
                    onClick={() => setActiveYear(tab.name)}
                  >
                    {tab.name}
                  </li>
                </>
              );
            })
            : null}
        </ul>
      </div>
      <div className="top-year-section month">
        <ul>
          {datas
            ? datas
              .filter(
                (x) =>
                  new Date(x.Create_date.split("(")[1].split(")")[0] * 1)
                    .toLocaleDateString("tr-TR")
                    .split(".")[2] == activeYear
              )
              .map((data) => (
                <li>
                  <a
                    target="_blank"
                    href={"https://sankoenerji.com.tr" + data.Image}
                  >
                    {data.Name_TR}
                  </a>
                </li>
              ))
            : ""}
        </ul>
      </div>
    </>
  );
};

export default ComplaintReport;
